import Contact from "@components/Contact/SendMail"
import { useRouteShellContext } from "@components/routeShellContext"
import { BigHeading } from "@components/SiteShell"
import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import * as m from "@paraglide/messages"
import type { ContactPageData } from "@site-types/publicPageData"
import { getLocalizedCareers } from "@utils/siteData"

export function ContactPage({
  data,
  selectedPosition = "",
  isSubPage = false,
}: {
  data: ContactPageData
  selectedPosition?: string
  isSubPage?: boolean
}) {
  const { locale } = useRouteShellContext()
  const careers = getLocalizedCareers(data, locale)
  const careerList = careers.map((career) => career.title ?? "").filter(Boolean)
  return (
    <>
      <BigHeading>
        {(m.contact_heading_label({}, { locale: locale }) || "Contact Us").toUpperCase()}
      </BigHeading>
      <div className="relative z-[5] mx-auto mb-[5em] max-w-[500px] p-8">
        <h1 className={isSubPage ? "mx-[0.4rem] mb-6" : "mb-6"}>
          {m.contact_form_heading({}, { locale: locale }) || "Contact Us"}
        </h1>
        <div className="mb-6">
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizeRichHtml(m.contact_form_description({}, { locale: locale })),
            }}
          />
        </div>
        <div className="m-2">
          <Contact
            careerList={careerList}
            selectedPosition={selectedPosition}
            selectedType={
              selectedPosition
                ? m.contact_formType_options_recruitment({}, { locale: locale }) || "Recruitment"
                : m.contact_formType_options_generalEnquiry({}, { locale: locale }) || "General Enquiry"
            }
          />
        </div>
      </div>
    </>
  )
}
